



















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
import { Dialog, Toast } from 'vant';
@Component
export default class NetworkForm extends Vue {
  loading: boolean = false;
  phone: string = '';
  password: string = '';
  networkAccount: string = '';
  verificationCode: string = '';
  isHaveNetworkAccount: boolean = true;
  show: boolean = true;
  count: number = 0;
  timer: any = null;
  @Prop() authKey: string;
  // 获取验证码
  async getCode() {
    if (this.phone.length < 1) {
      Dialog.alert({
        title: '提示',
        message: '请输入手机号。',
      });
      return;
    }
    try {
      const result = await api.AccountApp.sendSms_POST({
        Phone: this.phone,
      });
      if (result.success) {
        const TIME_COUNT = 30;
        if (!this.timer) {
          this.count = TIME_COUNT;
          this.show = false;
          this.timer = setInterval(() => {
            if (this.count > 0 && this.count <= TIME_COUNT) {
              this.count--;
            } else {
              this.show = true;
              clearInterval(this.timer);
              this.timer = null;
            }
          }, 1000);
        }
      } else {
        Dialog.alert({
          title: '提示',
          message: result.message,
        });
      }
    } catch (error) {
      Dialog.alert({
        message: error.toString(),
        title: '提示',
      });
    }
  }

  /**注册 */
  async regist(values: any) {
    try {
      const result = await api.AccountApp.platformRegisterNew_POST({
        AuthKey: this.authKey,
        Phone: values.phone,
        Pwd: values.password,
        UserName: values.networkAccount,
        VerCode: values.verificationCode,
      });
      return result;
    } catch (error) {
      Dialog.alert({
        title: '提示',
        message: error.toString(),
      });
    }
  }

  async onSubmit(values: any) {
    if (this.isHaveNetworkAccount) {
      if (values.networkAccount.length < 1) {
        Toast('请填写网院用户名。');
        return;
      }
      if (values.password.length < 1) {
        Toast('请填写网院账号的密码。');
        return;
      }
    }
    try {
      this.loading = true;
      const result: any = await this.regist(values);
      if (result!.success) {
        Dialog.alert({
          title: '提示',
          message: '绑定成功！点击确认自动登录。',
        });
        this.$emit('networkSuccess', result.data);
        this.loading = false;
      } else {
        if (result!.message.includes('微信用户信息已失效')) {
          Dialog.alert({
            title: '提示',
            message: result!.message + '(点击确认将刷新重新获取授权信息)',
          }).then(() => {
            this.$emit('refresh');
          });
        } else {
          Dialog.alert({
            title: '提示',
            message: result!.message,
          });
        }
        this.loading = false;
      }
    } catch (error) {
      Dialog.alert({
        title: '提示',
        message: error.toString(),
      });
      this.loading = false;
    }
  }
}
